import { render, staticRenderFns } from "./MapDetail.vue?vue&type=template&id=20e707fb&scoped=true&"
import script from "./MapDetail.vue?vue&type=script&lang=js&"
export * from "./MapDetail.vue?vue&type=script&lang=js&"
import style0 from "./MapDetail.vue?vue&type=style&index=0&id=20e707fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e707fb",
  null
  
)

export default component.exports